<div class="field">
    <label [for]="formControlName" class="font-medium text-900">
        {{label}}
     </label>

    <p-multiSelect 
        [options]="options"
        optionLabel="name"
        [id]="formControlName"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        [disabled]="isDisabled"
        class=""
        [class.ng-invalid]="control.invalid && (control.dirty || control.touched)"
        [class.ng-dirty]="control.invalid && (control.dirty || control.touched)">
    </p-multiSelect>
    <div *ngIf="control?.invalid && (control.dirty || control.touched)">
        <small class="text-red-400">{{errorMessage(control)}}</small>
    </div>
</div>